export const STRATEGY_TYPES = {
  SMART_PAGE: 'SMART_PAGE',
  ABM: 'ABM'
};